import './DataTableScrollShadow.css';
export var scrollShadow = {left:'_1al677r1-3-15-1 _1al677r0-3-15-1',right:'_1al677r2-3-15-1 _1al677r0-3-15-1'};
export var tableEdgeShadow = {left:'_1al677r3-3-15-1 _1al677r1-3-15-1 _1al677r0-3-15-1',right:'_1al677r4-3-15-1 _1al677r2-3-15-1 _1al677r0-3-15-1'};